import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const createSalesAndBudgets = (data) => {
  return apiActionCreator({
    'endpoint': '/dealers/sales',
    'authenticated': true,
    'types': [
      ActionTypes.CREATING_SALES_AND_BUDGETS,
      [
        ActionTypes.CREATED_SALES_AND_BUDGETS,
        (response) => buildSuccessMessage(response, 'Archivo guardado satisfactoriamente'),
      ],
      [
        ActionTypes.CREATED_SALES_AND_BUDGETS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });
};

export const clearSalesAndBudgetsData = () => ({
  'type': ActionTypes.CLEAR_SALES_AND_BUDGETS_DATA,
});

export const saveSalesAndBudgetsDataFromExcel = (list) => ({
  'type': ActionTypes.SAVE_SALES_AND_BUDGETS_DATA_FROM_EXCEL,
  'payload': list,
});

export const changeSalesAndBudgetsListPage = (value) => ({
  'type': ActionTypes.CHANGE_SALES_AND_BUDGETS_LIST_PAGE,
  'payload': value,
});

export const changeSalesAndBudgetsListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_SALES_AND_BUDGETS_LIST_PAGE_SIZE,
  'payload': value,
});
